import request from '../utils/request'
import global from '../config/global'
import coreServices from './core'

import { CipherType } from '../core-js/src/enums'
import { CipherView } from '../core-js/src/models/view'
import { CipherRequest } from '../core-js/src/models/request/cipherRequest'

async function list_ciphers(projectId = null) {
  return await global.jsCore.searchService.searchCiphers(
    null,
    [
      c => !c.isDeleted && c.type === CipherType.Environment,
      c => !projectId || c.organizationId == projectId,
    ],
    null
  ) || []
}

const get_payload = async (value, projectId) => {
  const cipher = new CipherView()
  cipher.type = CipherType.Environment
  cipher.organizationId = projectId
  cipher.environment = {
    name: value.name,
    externalUrl: value.externalUrl,
    description: value.description,
  }
  const cipherEnc = await global.jsCore.cipherService.encrypt(cipher)
  const cipherRequest = new CipherRequest(cipherEnc)
  const hash = await coreServices.hash_key_with_project_id(value.name, projectId)
  return {
    name: cipherRequest.environment.name,
    external_url: cipherRequest.environment.externalUrl,
    description: cipherRequest.environment.description,
    hash: hash
  }
}

async function hash_payload(ciphers) {
  const promises = ciphers.map(async (c) => ({
    id: c.id,
    hash: await coreServices.hash_key_with_project_id(c.environment.name, c.organizationId)
  }))
  const hashEnvironments = await Promise.all(promises);
  return {
    environments: hashEnvironments
  };
}

function list(project_id, params = {}) {
  return request({
    url: global.endpoint.PROJECT_ENVIRONMENTS.replace(':id', project_id),
    method: 'get',
    params
  })
}

function get(project_id, id, params = {}) {
  return request({
    url: global.endpoint.PROJECT_ENVIRONMENT.replace(':id', project_id).replace(':environment_id', id),
    method: 'get',
    params
  })
}

function create(project_id, data = {}) {
  return request({
    url: global.endpoint.PROJECT_ENVIRONMENTS.replace(':id', project_id),
    method: 'post',
    data
  })
}

function create_multiple(project_id, data = []) {
  return request({
    url: global.endpoint.PROJECT_ENVIRONMENTS_CREATE_MULTIPLE.replace(':id', project_id),
    method: 'post',
    data
  })
}

function update(project_id, id, data = {}) {
  return request({
    url: global.endpoint.PROJECT_ENVIRONMENT.replace(':id', project_id).replace(':environment_id', id),
    method: 'put',
    data
  })
}

function update_multiple(project_id, data = []) {
  return request({
    url: global.endpoint.PROJECT_ENVIRONMENTS_UPDATE_MULTIPLE.replace(':id', project_id),
    method: 'put',
    data
  })
}

function remove(project_id, id) {
  return request({
    url: global.endpoint.PROJECT_ENVIRONMENT.replace(':id', project_id).replace(':environment_id', id),
    method: 'delete'
  })
}

function remove_multiple(project_id, ids) {
  return request({
    url: global.endpoint.PROJECT_ENVIRONMENTS_DELETE_MULTIPLE.replace(':id', project_id),
    method: 'post',
    data: {
      environments: ids
    }
  })
}

export default {
  list_ciphers,
  get_payload,
  hash_payload,
  list,
  get,
  create,
  create_multiple,
  update,
  update_multiple,
  remove,
  remove_multiple
}
